module.exports = __webpack_public_path__ + "pic_bizny_web_06-375@2x.png?d8d1afb9dceed74f0ceda86b6c29e8c6";